module.exports = __webpack_public_path__ + "static/media/refresh.34f1c55d.png";